// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import TERMINAL from './metaData/terminal'
export default {
  state: TERMINAL,
  actions
}
